//import VueCookie from 'vue-cookie';
import router from '../router';

const actions = {
	
  
  navigatePages(state, payload) {

    // check direction of travel and whether we need to change it
    if (state.getters.getCurrentPageDirection != payload.direction) {
      state.commit('setPageDirection', payload.direction);
    } 
    
    const baseUrl = state.getters.getBaseUrl;
    const path = baseUrl+payload.path;

    // move to new route
    router.push({ path });

    // rester navigating flag
    state.commit('setNavigatingPages', false);
  },

  setActiveContent(state, payload) {


    // remove existing active content
    state.commit('setActiveContent', null);


    let error = false;

    if (!payload.pageId) {
        error = true;
    } else {
        
        // set the current page id
        state.commit('setCurrentPage', payload.pageId);
        
        const allContent = state.getters.getAllPageContent;
        if (!allContent[(parseInt(payload.pageId) - 1)]) {
            error = true;
        }

    }

    if (error) {

        // no content found, go home...
        const baseUrl = state.getters.getBaseUrl;

        // move to new route
        router.push({ path: baseUrl });
        return;

    }

    const allContent = state.getters.getAllPageContent;
    state.commit('setActiveContent', allContent[payload.pageId - 1]);

  },

  manageCookies(state, payload) {

    state.commit('setManagingCookies', payload);

  }



}

export default actions;

